import { styled } from '@slal/ui';
import { Text } from '../Typography';

export const StepContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;
    margin-bottom: 8px;
`;

export const Step = styled.div<{ isCompleted: boolean; isActive: boolean }>`
    height: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    background-color: ${({ isActive, isCompleted, theme }) => {
        if (isCompleted) return theme.colors.green__70;
        if (isActive) return theme.colors.blue__secondary__70;
        return theme.colors.neutral__light__40;
    }};
`;

export const StepLabel = styled(Text)`
    margin-bottom: 16px !important;
    color: ${({ theme }) => theme.colors.neutral__light__80};
`;

export const ProgressWrapper = styled.div`
    max-width: 430px;
`;

export const ProgressBarContainer = styled.div`
    max-width: 250px;
    background-color: ${({ theme }) => theme.colors.blue__primary__10};
    border-radius: 13px;
    overflow: hidden;
`;

export const Progress = styled.div<{ percentage: number }>`
    width: ${({ percentage }) => percentage}%;
    height: 4px;
    background-color: ${({ theme }) => theme.colors.aqua__80};
    transition: width 0.3s ease-in-out;
`;

export const StepLabelWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 250px;
    h4 {
        margin-bottom: 8px !important;
    }
`;
